import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Product/inventory GET requests must always revalidate against the backend.
// The timestamp also defeats intermediary/browser caches without disabling
// caching of static assets such as images and JavaScript bundles.
axios.defaults.headers.common["Cache-Control"] = "no-cache, no-store, must-revalidate";
axios.defaults.headers.common["Pragma"] = "no-cache";
axios.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

export const getProducts = (params = {}) => axios.get(`${API}/products`, { params }).then((r) => r.data);
export const getProduct = (id) => axios.get(`${API}/products/${id}`).then((r) => r.data);
export const createOrder = (payload) => axios.post(`${API}/orders`, payload).then((r) => r.data);
export const getOrder = (id) => axios.get(`${API}/orders/${id}`).then((r) => r.data);
export const trackOrder = (order_number, email) =>
  axios.post(`${API}/orders/track`, { order_number, email }).then((r) => r.data);
export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const razorpayCreateOrder = (order_id, origin_url) =>
  axios.post(`${API}/payments/razorpay/order`, { order_id, origin_url }).then((r) => r.data);
export const razorpayVerify = (payload) =>
  axios.post(`${API}/payments/razorpay/verify`, payload).then((r) => r.data);
export const razorpayCancel = (order_id) =>
  axios.post(`${API}/payments/razorpay/cancel`, { order_id }).then((r) => r.data);
export const createPaymentCheckout = (order_id, origin_url) =>
  axios.post(`${API}/payments/checkout`, { order_id, origin_url }).then((r) => r.data);
export const getPaymentStatus = (session_id) =>
  axios.get(`${API}/payments/status/${session_id}`).then((r) => r.data);

const adminHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("vaiyra_admin_token")}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);
export const stockGetOrders = () => axios.get(`${API}/stock/orders`, adminHeaders()).then((r) => r.data);
export const stockGetProducts = () => axios.get(`${API}/stock/products`, adminHeaders()).then((r) => r.data);
export const stockUpdateOrderStatus = (id, status) =>
  axios.patch(`${API}/stock/orders/${id}/status`, { status }, adminHeaders()).then((r) => r.data);
export const stockUpdateProductStock = (id, stock) =>
  axios.patch(`${API}/stock/products/${id}/stock`, { stock }, adminHeaders()).then((r) => r.data);
export const adminGetOrders = () => axios.get(`${API}/admin/orders`, adminHeaders()).then((r) => r.data);
export const adminGetSettings = () => axios.get(`${API}/admin/settings`, adminHeaders()).then((r) => r.data);
export const adminUpdateSettings = (payload) =>
  axios.put(`${API}/admin/settings`, payload, adminHeaders()).then((r) => r.data);
export const adminUpdateOrderStatus = (id, status) =>
  axios.patch(`${API}/admin/orders/${id}/status`, { status }, adminHeaders()).then((r) => r.data);
export const adminCreateProduct = (payload) =>
  axios.post(`${API}/admin/products`, payload, adminHeaders()).then((r) => r.data);
export const adminUpdateProduct = (id, payload) =>
  axios.put(`${API}/admin/products/${id}`, payload, adminHeaders()).then((r) => r.data);
export const adminDeleteProduct = (id) =>
  axios.delete(`${API}/admin/products/${id}`, adminHeaders()).then((r) => r.data);
export const adminUploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/admin/upload`, form, { headers: { Authorization: `Bearer ${localStorage.getItem("vaiyra_admin_token")}` } })
    .then((r) => r.data);
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const imgSrc = (src) =>
  src && src.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_1f4947ee-f69c-4271-979a-e9b2ce024001/artifacts/cz6ozmxb_44dbab43-5139-4353-a586-9e0d5d95a3b1.jpeg";
